import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/entitlement/entitlements/entitlementsShippingInfo/initialState.entitlementsShippingInfo.data';
import {
    fetchEntitlementsShippingInfoById as fetchEntitlementsShippingInfoByIdAPI,
} from '../../../../apis/entitlementsShippingInfoAPI';
import { handlePending, handleRejection } from '../../../../constants';
import { createAsyncThunkWrapper } from '../../../../services/common/asyncThunkWrapper';
import { ACTIONS_ENTITLEMENT_SHIPPINGINFO } from '../../../../constants/actionCreator';

//API to get data by Entitlement Id for Entitlements
export const fetchEntitlementsShippingInfoDataById = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_SHIPPINGINFO.FETCH_SHIPPING_INFO,
  fetchEntitlementsShippingInfoByIdAPI
);

const entitlementsShippingInfoSlice = createSlice({
  name: 'entitlementsShippingInfo',
  initialState,
  reducers: {
    //Additional Events/Functions capture here
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEntitlementsShippingInfoDataById.pending, (state, action) => {
        handlePending(state, action);
        state.isEntitlementsByIdResultsFound = null;
        state.isEntitlementsLoading = true;
      })
      .addCase(fetchEntitlementsShippingInfoDataById.fulfilled, (state, action) => {
        state.loading = false;
        state.entitlementsShippingInfoData = action.payload ? action.payload : [];
        state.isEntitlementsShippingInfoByIdResultsFound = action.payload?.length === 0;
      })
      .addCase(fetchEntitlementsShippingInfoDataById.rejected, (state, action) => {
        handleRejection(state, action);
        state.loading = false;
        state.isEntitlementsShippingInfoByIdResultsFound = true;
        state.isEntitlementsLoading = false;
      });
  },
});

export default entitlementsShippingInfoSlice.reducer;
